exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading h4[data-v-b0cfd920]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.panel-flat[data-v-b0cfd920]{overflow-x:hidden!important}.address-card[data-v-b0cfd920]{background-color:#ffebee;border:1px solid #ffcdd2;border-radius:8px;padding:12px}.address-card-title[data-v-b0cfd920]{font-weight:700;font-size:15px;margin-bottom:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b0cfd920","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/addNewShipOnly.vue
// module id = 845
// module chunks = 0